import styled from "styled-components";

export const StyledDiv = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
`;

export const StyledImg = styled.img`
  position: relative;
  left: 1px;
  top: 1px;
  height: 240px;
  width: calc(100% - 1px);
  object-fit: cover;
  overflow: hidden;
`;

export const StyledButtonWapper = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
`;

export const StyledWrapper = styled.div`
  max-width: 360px;
  height: 100%;
`;

export const StyledTextDiv = styled.div`
  padding-top: 1.1em;
`;
